module.exports = __webpack_public_path__ + "media/packs/src/assets/images/event-9065558b3f9f8806e7f9e4efaa7fc489.png";